<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.obstetricConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <!--                <div class="card-title">-->
                <!--                    <b-button class="mb-2" variant="primary" @click="toUltrasounds">-->
                <!--                        {{ $tc('message.ultrasounds', 2) }}-->
                <!--                    </b-button>-->
                <!--                    <b-button class="mb-2" variant="primary" @click="toPrenatalsConsultations">-->
                <!--                        {{ $tc('message.prenatalConsultations', 2) }}-->
                <!--                    </b-button>-->
                <!--                    <b-button class="mb-2" variant="primary" @click="toAllergie">-->
                <!--                        {{ $tc('message.allergies', 2) }}-->
                <!--                    </b-button>-->
                <!--                    <b-button class="mb-2" variant="primary" @click="toCurrentTraitement">-->
                <!--                        {{ $t('message.currentTreatments') }}-->
                <!--                    </b-button>-->

                <!--                    <b-button class="mb-2" variant="primary" @click="toAntecedent">-->
                <!--                        {{ $tc('message.antecedents', 2) }}-->
                <!--                    </b-button>-->
                <!--                </div>-->

                <div class="card">

                    <div class="card-body p-1em">
                        <b-tabs
                                card
                                content-class="mt-3"
                                fill
                                active-nav-item-class="font-weight-bold text-uppercase text-success"

                        >
                            <b-tab no-body :title="$t('message.infoConsultation')"
                            >
                                <b-container>
                                    <b-row>
                                        <b-col  sm="8">
                                            <div class="list-group list-group-flush">
                                                <b-row>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">  {{ $t('message.institutionConsultation') }} :</h4>
                                                            <span class="font-weight-bold consultation-item__body">
                                                    <p> {{ etablissement }} </p>
                                                </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.practitioners',1) }} </h4>
                                                            <span class="font-weight-bold consultation-item__body">
                                                    <p> {{ praticien }} </p>
                                                </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            {{ $t('message.consultationDate') }}:

                                                            <span class="font-weight-bold">
                                {{ formattedDate(mConsultation.date_creation) }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">  {{ $t('message.pregnancyNumber') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.numero_grossesse }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">  {{ $t('message.ddr') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ formattedDate(mConsultation.ddr) }}
                            </span>
                                                        </div>
                                                    </b-col>


                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $t('message.amenorrheaWeek') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ amenorrhea }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $t('message.serology') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.serologie }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">  {{ $t('message.bloodGroup') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.groupe_sanguin }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $t('message.familyStatus') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.statut_socio_familiale }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.addictions', 2) }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.assuetudes }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.transfusionAntecedent') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.antecedent_de_transfusion }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $t('message.riskFactor') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.facteur_de_risque }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $t('message.antecedentSpouse') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.antecedent_conjoint }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $t('message.rcc') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.rcc }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $tc('message.pcr',1) }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.pcr_gonocoque }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $tc('message.pcr',2) }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.pcr_chlamydia }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $tc('message.emu') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.emu }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.tsh') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.tsh }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.antiTpo') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.anti_tpo }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $tc('message.ft4') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.ft4 }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title"> {{ $tc('message.ft3') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.ft3 }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.infoSupported') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.info_prise_en_charge }}
                            </span>
                                                        </div>
                                                    </b-col>

                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $tc('message.warning') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{ mConsultation.attention }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $t('message.t1') }}:</h4>

                                                            <span class="font-weight-bold consultation-item__body">
                                {{(mConsultation.t1 == 'nipt' ? 'nipt'.toLocaleUpperCase() : mConsultation.t1) }}
                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-row v-if="mConsultation.t1 == 'nipt'">
                                                        <b-col sm="12">
                                                            <div class="list-group-item">
                                                                <h4 class="consultation-item__title"> {{ $t('message.nle_anle') }}:</h4>

                                                                <span class="font-weight-bold consultation-item__body">
                                {{mConsultation.nle_anle }}
                            </span>
                                                            </div>
                                                        </b-col>
                                                        <b-col sm="12">
                                                            <div class="list-group-item">
                                                                <h4 class="consultation-item__title"> {{ $t('message.gender') }}:</h4>

                                                                <span class="font-weight-bold consultation-item__body">
                                {{mConsultation.sexe }}
                            </span>
                                                            </div>
                                                        </b-col>


                                                    </b-row>
                                                    <b-col col sm="12" v-if="mConsultation.rdv">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $t('message.appointmentDate') }} </h4>

                                                            <p class="consultation-item__body" v-html="mConsultation.rdv.date"></p>

                                                        </div>
                                                    </b-col>
                                                    <b-col col sm="12" v-if="mConsultation.rdv">
                                                        <div class="list-group-item">
                                                            <h4 class="consultation-item__title">{{ $t('message.appointmentReason') }} </h4>

                                                            <p class="consultation-item__body" v-html="mConsultation.rdv.motifs"></p>

                                                        </div>
                                                    </b-col>
                                                    </b-row>
                                                <b-row>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            {{ $t('message.passedAt') }}:

                                                            <span class="font-weight-bold">
                                                                {{ formattedDate(mConsultation.passed_at) }}
                                                            </span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="12">
                                                        <div class="list-group-item">
                                                            {{ $t('message.archievedAt') }}:

                                                            <span class="font-weight-bold">
                                                                {{ formattedDate(mConsultation.archieved_at) }}
                                                            </span>
                                                        </div>
                                                    </b-col>

                                                </b-row>
                                            </div>

                                        </b-col>
                                        <b-col sm="4">
                                            <div class="card-footer text-right">
                                                <b-row class="justify-content-sm-center">
                                <span v-if="errorshasField('nonTransmis')" style="color:red">
                                    {{getErrorsField('nonTransmis')}}
                                    </span>
                                                </b-row>

                                                <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                                                    {{ $t('message.edit') }}
                                                </b-button>
                                                <br>
                                                <br>

                                                <b-button variant="success" @click="archieveConsultation" v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole || hasAssistante)" >
                                                    {{ $t('message.archieve') }}
                                                </b-button>
                                                <br>
                                                <br>

                                                <b-button variant="info" @click="transmitConsultation" v-if="isTransmitted(mConsultation.passed_at) && (hasPraticienRole || hasAdminRole || hasMedecinControleRole || hasAssistante)">
                                                    {{ $t('message.transmit') }}
                                                </b-button>
                                                <br>
                                                <br>
                                                <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                                                    {{ $t('message.reavivate') }} {{$tc('message.consultations',1) }}
                                                </b-button>
                                                <br>
                                                <br>
                                                <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                                                    {{ $t('message.delete') }}
                                                </b-button>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>

                            </b-tab>
                            <b-tab :title="$tc('message.ultrasounds',2)">
                                <b-link class="ml-4"
                                        :to="{ name: 'add-ultrasound' }"
                                        variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante"
                                >
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.ultrasounds',1) }}
                                </b-link>
                                <b-card-body>
                                    <vue-good-table
                                            id="echographie"
                                            :columns="echograhiesColumns"
                                            :rows="echographiesRows"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            :groupOptions="enabled"
                                            @on-row-click="onEchographieRowClick"


                                    />
                                </b-card-body>
                            </b-tab>
                            <b-tab :title="$tc('message.prenatalConsultations',2)">
                                <b-link class="ml-4"
                                        @click="toAddPrenatal"
                                        variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante"
                                >
                                    <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.prenatalConsultations',1) }}
                                </b-link>
                                <b-card-body>
                                    <vue-good-table
                                            id="prenatal"
                                            :columns="prenatalsColumns"
                                            :rows="prenatalsRows"
                                            :search-options="enabled"
                                            :pagination-options="paginationOptions"
                                            @on-row-click="onPrenatalRowClick"
                                    />
                                </b-card-body>
                            </b-tab>
                            <b-tab no-body :title="$t('message.infoAllergies')">
                                <b-col sm="12">
                                    <div class="list-group list-group-flush" id="allergie">
                                        <b-link class="ml-4"
                                                variant="primary"
                                                @click="toAllergie"
                                                v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                                            <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                                        </b-link>

                                        <b-card-body>
                                            <vue-good-table
                                                    v-if="allergiesRows"
                                                    :columns="allergiesColumns"
                                                    :rows="allergiesRows"
                                                    :search-options="enabled"
                                                    :pagination-options="paginationOptions"
                                                    @on-row-click="onAllergieRowClick"
                                            />
                                        </b-card-body>
                                    </div>
                                </b-col>
                            </b-tab>
                            <b-tab no-body :title="$t('message.infoAntecedents')">
                                <b-col sm="12">
                                    <div class="list-group list-group-flush" id="antecedent">
                                        <b-link class="ml-4" variant="primary"
                                                @click="toAntecedent"
                                                v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole || hasAssistante"
                                        >
                                            <i class="fas fa-plus-circle edit-icon"></i>  {{ $t('message.add') }} {{ $tc('message.antecedents', 1) }}
                                        </b-link>

                                        <b-card-body>
                                            <vue-good-table
                                                    v-if="antecedentsRows"
                                                    :columns="antecedentsColumns"
                                                    :rows="antecedentsRows"
                                                    :search-options="enabled"
                                                    :pagination-options="paginationOptions"
                                                    :groupOptions="enabled"
                                                    :sort-options="sort"
                                                    @on-row-click="onAntecedentRowClick"

                                            />
                                        </b-card-body>
                                    </div>
                                </b-col>
                            </b-tab>
                            <b-tab no-body :title="$t('message.currentTreatments')">
                                <b-col sm="12">
                                    <div class="list-group list-group-flush" id="traitement">
                                        <b-link class="ml-4"
                                                @click="toCurrentTraitement"
                                                variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante"
                                        >
                                            <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
                                        </b-link>

                                        <b-card-body>
                                            <vue-good-table
                                                    v-if="traitementsRows"
                                                    :columns="traitementsColumns"
                                                    :rows="traitementsRows"
                                                    :search-options="enabled"
                                                    :pagination-options="paginationOptions"
                                                    @on-row-click="onTraitementRowClick"

                                            />
                                        </b-card-body>
                                    </div>
                                </b-col>
                            </b-tab>


                        </b-tabs>
                    </div>


                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.obstetricConsultations', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mConsultation.numero_grossesse }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteConsultation">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from "lodash";

    export default {
        name: "Obstetric",

        computed: {
            ...mapGetters(["obstetricConsultation",
                "errors",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole']),

            mConsultation: function() {
                return this.obstetricConsultation;
            },


            praticien:function(){
                let author = this.mConsultation.author;
                if (!_.isNull(author)){
                    if (author.hasOwnProperty('user')){
                        let user = author.user
                        if (!_.isUndefined(user) && !_.isNull(user)) {
                            let prenom = (user.prenom == null) ? '' : user.prenom;
                            return (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        }
                    }else{
                        if (!_.isUndefined(author) && !_.isNull(author)) {
                            let prenom = (author.prenom == null) ? '' : author.prenom;
                            return (author.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        }
                    }
                }
                return  "";
            },

            prenatalsRows:function(){
                let pArray = [];

                _.forEach(this.mConsultation.consultation_prenatales, function (prenatal) {
                    pArray.push({
                        type:prenatal.type_de_consultation,
                        plaintes:prenatal.plaintes,
                        recommandations:prenatal.recommandations,
                        examen_clinique:prenatal.examen_clinique,
                        examen_complementaire: prenatal.examen_complementaire,
                        slug:prenatal.slug
                    });
                });
                return pArray;
            },

            antecedentsRows:function(){
                if(!_.isUndefined(this.mConsultation.dossier)) {
                    return _.chain(this.mConsultation.dossier.antecedents)
                        .groupBy("type")
                        .map((value, key) => ({ mode: "span", label: key, html:false, children: value }))
                        .value();
                }
                return [];
            },

            echographiesRows:function(){
                let eArray = [];
                let oeArray = [];

                _.forEach(this.mConsultation.echographies, function (echographie) {
                    oeArray.push({
                        type:echographie.type,
                        ddr:echographie.ddr,
                        dpa:echographie.dpa,
                        semaine_amenorrhee:echographie.semaine_amenorrhee,
                        slug: echographie.slug
                    });
                });

                eArray.push({mode: "span", label: "Grossesse n° " + this.mConsultation.numero_grossesse, html:false,
                    children: oeArray
                });

                return eArray;
            },

            allergiesRows:function(){
                let aArray = [];
                if(!_.isUndefined(this.mConsultation.dossier)) {
                    _.forEach(this.mConsultation.dossier.allergies, function (allergy) {
                        aArray.push({description: allergy.description, date: allergy.date, slug: allergy.slug})
                    })
                }
                return aArray;
            },

            traitementsRows:function(){
                let tArray = [];
                if(!_.isUndefined(this.mConsultation.dossier)) {
                    _.forEach(this.mConsultation.dossier.traitements, function (traitement) {
                        tArray.push({description: traitement.description,slug:traitement.slug})
                        // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
                    });
                }
                return tArray;
            },

            etablissement:function(){
                if (!_.isUndefined(this.mConsultation.etablissement)){
                    if (!_.isNull(this.mConsultation.etablissement)){
                        return this.mConsultation.etablissement.name;
                    }
                    return "";
                }
                return  "";
            },

            fullName:function(){
                if (typeof (this.mConsultation.user) == 'object'){
                    let user = this.mConsultation.user;
                    return user.prenom? user.prenom+ ' ' : '' + user.nom ? user.nom :'';
                }else{
                    return '';
                }
            },

            fileNumber:function() {
                if (typeof (this.mConsultation.dossier) == 'object'){
                    let dossier = this.mConsultation.dossier;
                    return dossier.numero_dossier;
                }else{
                    return '';
                }
            },

            canReactive:function(){
                return !_.isNull(this.mConsultation.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole || this.hasAssistante);
            },

            canUpdate:function(){
                return this.mConsultation.canUpdate;
            },

            amenorrhea:function () {
                return Math.trunc(moment.duration((moment().toDate() - moment(this.mConsultation.ddr).toDate())).asWeeks());
            },

            canDelete:function(){
                if (this.hasAdminRole)
                    return true;

                return this.mConsultation.canUpdate && _.isNull(this.mConsultation.archieved_at) && _.isNull(this.mConsultation.passed_at);
            },
        },

        data() {
            return {
                consultation_id: this.$route.params.consultation,

                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},

                sort:{
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

                antecedentsColumns:[
                    {
                        label: this.$i18n.tc('message.types',1),
                        field: 'type',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                    },
                    {
                        label: this.$i18n.t('message.startDate'),
                        field: 'date',
                        type: 'date',
                        dateInputFormat: 'yyyy-MM-dd',
                        dateOutputFormat: 'dd/MM/yyyy',
                    },
                ],

                echograhiesColumns:[
                    {
                        label: this.$i18n.tc('message.types',2),
                        field: 'type',
                    },
                    {
                        label: this.$i18n.t('message.ddr'),
                        field: 'ddr',
                        type: 'date',
                        dateInputFormat: 'yyyy-MM-dd',
                        dateOutputFormat: 'dd/MM/yyyy',
                    },
                    {
                        label: this.$i18n.t('message.dpa'),
                        field: 'dpa',
                        type: 'date',
                        dateInputFormat: 'yyyy-MM-dd',
                        dateOutputFormat: 'dd/MM/yyyy',
                    },
                    {
                        label: this.$i18n.t('message.amenorrheaWeek'),
                        field: 'semaine_amenorrhee',
                    },

                ],

                allergiesColumns: [
                    {
                        label: 'Description',
                        field: 'description',
                    },
                    // {
                    //     label: this.$i18n.t('message.startDate'),
                    //     field: 'date',
                    //     type: 'date',
                    //     dateInputFormat: 'yyyy-MM-dd',
                    //     dateOutputFormat: 'dd/MM/yyyy',
                    // },
                ],

                prenatalsColumns: [
                    {
                        label: this.$i18n.t('message.typeOfConsultation'),
                        field: 'type',
                    },

                    {
                        label: this.$i18n.tc('message.complaints',2),
                        field: 'plaintes',
                    },

                    {
                        label: this.$i18n.tc('message.recommendations',2),
                        field: 'recommandations',
                    },

                    {
                        label: this.$i18n.tc('message.physicalExams',2),
                        field: 'examen_clinique',
                    },

                    {
                        label: this.$i18n.tc('message.complementaryExams',2),
                        field: 'examen_complementaire',
                    },

                ],

                traitementsColumns:[
                    {
                        label: 'Description',
                        field: 'description',
                    },
                    // {
                    //     label: this.$i18n.t('message.prescriptionDate'),
                    //     field: 'date',
                    //     type: 'date',
                    //     dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                    //     dateOutputFormat: 'dd/MM/yyyy',
                    // },
                ],
            }
        },

        methods: {

            onEchographieRowClick(params){
                this.$router.push({ name: 'ultrasound', params: { ultrasound: params.row.slug } });
            },

            onPrenatalRowClick(params){
                this.$router.push({ name: 'consultation-prenatal', params: { consultation: params.row.slug } });
            },

            onTraitementRowClick(params){
                this.$router.push({ name: 'treatment', params: { treatment: params.row.slug } });
            },

            onAntecedentRowClick(params){
                this.$router.push({ name: 'antecedent', params: { antecedent: params.row.slug, file: this.generalConsultation.dossier.slug } });
            },

            onAllergieRowClick(params){
                this.$router.push({ name: 'allergy', params: { allergy: params.row.slug } });
            },

            reactiveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.obstetriqueConsultationReactived');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('reactiveObstetricConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            toAllergie(){
                this.$router.push({ name: 'add-allergy', params: { file: this.obstetricConsultation.dossier.slug } })
            },

            toCurrentTraitement(){
                this.$router.push({ name: 'add-treatments', params: { file: this.obstetricConsultation.dossier.slug } })
            },

            toAntecedent(){
                this.$router.push( { name: 'add-antecedent', params: { file: this.obstetricConsultation.dossier.slug }})
            },

            toAddPrenatal(){
                this.$router.push( { name: 'add-consultation-prenatal', params: { consultation: this.obstetricConsultation.slug }  })
            },

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getObstetricConsultation", { args });
            },

            formattedDate(date) {
                return date ? moment(date).format('DD-MM-YYYY') : 'not yet';
            },

            toUltrasounds() {
                this.$router.push({ name: 'ultrasounds', params: { consultation: this.consultation_id } })
            },

            toPrenatalsConsultations(){
                this.$router.push({ name: 'consultations-prenatals-per-obstetric', params: { consultation: this.consultation_id } })
            },

            updateConsultation() {
                this.$router.push({ name: 'edit-consultation-obstetric', params: { consultation: this.consultation_id } });
            },

            archieveConsultation(){
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.obstetricConsultationArchieved');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('archieveObstetricConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            transmitConsultation(){
                this.clearErrorField('nonTransmis');
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.obstetricConsultationTransmitted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('transmitObstetricConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

            },

            deleteConsultation() {
                let self = this;
                let args = {
                    consultation: this.consultation_id
                };

                let successMessage = this.$i18n.t('message.obstetricConsultationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteObstetricConsultation', { args, index: self.consultation_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();
                });
            },

            isArchived:function(date){
                let momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            isTransmitted:function(date){
                var momentDate = moment(date);
                return !momentDate.isValid() ;
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        mounted() {
            this.getConsultation();
        }
    }
</script>

<style scoped>

</style>